import Vue from "vue";
import VueI18n from "vue-i18n";
import { useI18n } from "@/const/map/i18n.js";
import { registrationCmps } from "@/utils/registrationCmps";
import { getCsrCmpItemState } from '@/store/state';
import { getStore } from "@/store/index";
import { useCacheCsrVm, useCsrVm } from "@/hooks/common/useCsrVm";
import { v4 as uuidv4 } from 'uuid';


// 获取html上的lang属性来取对应的i18n
const getLang = () => {
  let lang = document?.documentElement?.getAttribute?.('lang') ?? "en";
  lang = lang.split('-')[0];
  return lang;
}

export const useCsrCmpSet = (csrCmpSet) => {
  const renderAllCsrCmp = (force = false) => {
    // const { site } = document.body.dataset;
    const site = getLang();
    const i18nMap = useI18n(site);
    Vue.use(VueI18n);
    const i18n = new VueI18n({
      locale: site, // 这里可以改成其他国家locale
      messages: {
        [site]: {
          message: i18nMap,
        },
      },
    });
    // 注册全局组件
    Vue.use(registrationCmps, {
      i18n: (key) => {
        const position = key.split('.');
        let value = null;
        position.forEach(key => {
          value = value ? value[key] : i18nMap[key]
        });
        return value;
      },
    });
    Vue.config.productionTip = false;

    // 渲染csr组件
    const crsComponents = document.querySelectorAll(".csr-cmp");
    crsComponents.forEach((item) => {
      const { id, dataset } = item;
      const vm = useCsrVm(id);
      const { cmp } = dataset;
      const Component = csrCmpSet[cmp];
      // 若不存在对应组件 或者 节点已渲染，则退出
      if (!Component || vm || !item.querySelector(".csr-cmp__content")) { return; }
      // 用于author环境拖组件时的渲染
      if (force) {
        // 在store中添加state
        const store = getStore();
        const state = getCsrCmpItemState(item);
        store.addCsrState(id, state);
      }
      // 将实例挂载到对应的dom节点上
      useCacheCsrVm(id, new Vue({
        el: item.querySelector(".csr-cmp__content"),
        i18n,
        render(h) {
          return h(csrCmpSet[cmp], {
            ref: id,
            props: {
              stateKey: id,
            },
          });
        },
      }));
    });
  };


  // 强制渲染所有csr组件
  const renderAllCsrCmpForce = () => {
    renderAllCsrCmp(true)
  }

  // 手动渲染某个特定的组件
  const renderCsrCmpManually = ({
    cmpName,
    mountDom,
    options,
  }) => {
    if (!cmpName || !csrCmpSet[cmpName]) { return; }
    // const { site } = document.body.dataset;
    const site = getLang();
    const i18nMap = useI18n();
    Vue.use(VueI18n);
    const i18n = new VueI18n({
      locale: site, // 这里可以改成其他国家locale
      messages: {
        [site]: {
          message: i18nMap,
        },
      },
    });
    // 注册全局组件
    Vue.use(registrationCmps, {
      i18n: (key) => {
        const position = key.split('.');
        let value = null;
        position.forEach(key => {
          value = value ? value[key] : i18nMap[key]
        });
        return value;
      },
    });
    Vue.config.productionTip = false;

    // 渲染csr组件
    const crsComponents = Object.prototype.toString.call(mountDom) === "[object String]" ? document.querySelectorAll(mountDom) : [mountDom];
    crsComponents?.forEach((item) => {
      let { id } = item
      const { dataset = {} } = item;
      if (!id) {
        id = `${cmpName}-${uuidv4()}`;
        item.setAttribute("id", id);
      }
      const vm = useCsrVm(id);
      const Component = csrCmpSet[cmpName];
      // 若不存在对应组件 或者 节点已渲染，则退出
      if (!Component || vm) { return; }
      // 用于author环境拖组件时的渲染
      // if (force) {
      // 在store中添加state
      const store = getStore();
      const state = getCsrCmpItemState(item);
      store.addCsrState(id, state);
      // }

      const datasetObj = {};
      // eslint-disable-next-line
      for (const key in dataset) {
        datasetObj[key] = dataset[key];
      }
      // 将实例挂载到对应的dom节点上
      useCacheCsrVm(id, new Vue({
        el: item,
        i18n,
        render(h) {
          return h(csrCmpSet[cmpName], {
            ref: id,
            props: {
              stateKey: id,
              ...options,
              dataset: datasetObj
            },
          });
        },
      }));
    });
  }

  return {
    renderAllCsrCmp,
    renderAllCsrCmpForce,
    renderCsrCmpManually,
  }
}
